import { render, staticRenderFns } from "./ProductIncipit.vue?vue&type=template&id=ff887072&scoped=true"
import script from "./ProductIncipit.vue?vue&type=script&lang=ts"
export * from "./ProductIncipit.vue?vue&type=script&lang=ts"
import style0 from "./ProductIncipit.vue?vue&type=style&index=0&id=ff887072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff887072",
  null
  
)

export default component.exports